import { Component, OnInit, ViewChild } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { HttpService } from 'src/app/http.service';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { environment } from '../../../environments/environment';
declare var jQuery: any;
import * as moment from 'moment';
import { CanonicalService } from '../../shared/canonical.service';
import { Router } from '@angular/router';

function ValidateEmail(control: AbstractControl): { [key: string]: Boolean } | null {

  // let regularExp = /^([\w.-]+)@(\[(\d{1,3}\.){3}|(?!hotmail|gmail|yahoo|outlook)(([a-zA-Z\d-]+\.)+))([a-zA-Z]{2,4}|\d{1,3})(\]?)$/;
  let regularExp = /^([\w.-]+)@((?!hotmail|gmail|yahoo|outlook)([a-zA-Z\d-]+\.)+)([a-zA-Z]{2,4}|\d{1,3})(\]?)$/;

  if (control.value !== undefined && !regularExp.test(control.value)) {
    return { "isValidEmail": true };
  }
  return null;
}

@Component({
  selector: 'app-app-protectt-lite',
  templateUrl: './app-protectt-lite.component.html',
  styleUrls: ['./app-protectt-lite.component.css']
})
export class AppProtecttLiteComponent implements OnInit {

  demoForm: FormGroup;
  @ViewChild('closebutton') closebutton: any;
  cilentIPAddress = '';
  subscribeForm: FormGroup;
  demoSubmitted = false;
  submittedSub = false;
  public message: any;
  innerWidth: number = window.innerWidth;
  currentRoutePath: any;
  heading = "Enhance Your Mobile App Security Effortlessly";
  subheading = "Apply Our Innovative Runtime Application Self Protection (RASP) Enabled SDK";

  constructor(private titleService: Title, private metaTagService: Meta, private metaTagService1: Meta, private httpService: HttpService, public fb: FormBuilder, private canonicalService: CanonicalService, public router: Router) {

    this.canonicalService.setCanonicalURL("https://www.protectt.ai/appprotectt-lite");

    this.httpService.getIPAddress().subscribe((res: any) => {
      this.cilentIPAddress = res.ip;
    });

    this.subscribeForm = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]{1,64}@[a-z0-9.-]+\\.[a-z]{2,4}$'), ValidateEmail])],
    });
    this.demoForm = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]{1,64}@[a-z0-9.-]+\\.[a-z]{2,4}$'), ValidateEmail])],
      name: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.pattern('^[A-Za-z ]+$')])],
      designation: ['', Validators.compose([Validators.required, Validators.maxLength(50)])],
      message: [''],
      contactnumber: ['', Validators.compose([Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")])],
      company_name: ['', Validators.compose([Validators.required])],
      time_slot1: ['', Validators.compose([Validators.required])],
      time_slot2: [''],
    });

  }

  ngOnInit(): void {
    this.titleService.setTitle('Best Mobile App Security Solution for Android & iOS App | Protectt.ai');
    this.metaTagService1.updateTag({ name: 'title', content: 'Best Mobile App Security Solution for Android & iOS App | Protectt.ai' });
    this.metaTagService.updateTag({ name: 'description', content: 'Get the latest Cyber Security for your mobile apps. We provide features specifically for your Business, including RASP enabled with SDK. Check out the all in one best mobile security for your business apps.' });
  }

  myFunction(btnid: any) {
    var elem = jQuery("#" + btnid + "-btn")[0].innerHTML;
    if (elem == "Read More ↓") {
      jQuery("#" + btnid + "-btn").text("Read Less ↑");
      jQuery("." + btnid).slideDown();
      jQuery('.' + btnid + '.dots').hide();
    } else {
      jQuery("#" + btnid + "-btn").text("Read More ↓");
      jQuery("." + btnid).slideUp();
      jQuery('.' + btnid + '.dots').show();
    }
  }

  submitDemoForm() {
    let dateString1 = this.demoForm.get('time_slot1')!.value;
    let dateString2 = this.demoForm.get('time_slot2')!.value;
    var dateTimeSlot1 = moment(dateString1).format('DD-MM-YYYY HH:MM');
    var dateTimeSlot2 = moment(dateString2).format('DD-MM-YYYY HH:MM');
    let url = environment.API_URL + "requestdemo";
    let urlValue = "";
    this.demoSubmitted = true;
    if (this.demoForm.invalid) {
      return;
    } else {
      if (url.includes("dev.website")) {
        urlValue = "nonprod"
      } else {
        urlValue = "prod"
      }
      var demoData = {
        email: this.demoForm.get('email')!.value,
        name: this.demoForm.get('name')!.value,
        designation: this.demoForm.get('designation')!.value,
        message: this.demoForm.get('message')!.value,
        contactnumber: this.demoForm.get('contactnumber')!.value,
        companyname: this.demoForm.get('company_name')!.value,
        timeslot1: dateTimeSlot1,
        timeslot2: dateTimeSlot2,
        ipaddress: this.cilentIPAddress,
        weburl: urlValue,
        adcampurl: this.currentRoutePath
      };
      let data = {
        salesLeadData: demoData,
      }
      let encryptMsg = JSON.stringify(data);
      let encMsg = this.httpService.encryptText(encryptMsg, HttpService.SECRET_KEY);
      let postData = {
        encryptedRequest: encMsg
      }

      this.httpService.postAPIMethod(url, postData).subscribe(
        res => {
          let decRes = this.httpService.decryptText(res, HttpService.SECRET_KEY);
          let decMsg = decRes;
          let resp: any = JSON.parse(decMsg);
          alert(resp['statusDesc']);
          // this.subRespData = JSON.parse(decMsg);
        },
        error => {
        });

      this.demoSubmitted = false;
      // alert("Request has been submitted..");
      this.closebutton.nativeElement.click();
    }
  }

  onReset() {

    this.message = '';
    this.demoForm.reset();
    this.subscribeForm.reset();
    this.demoSubmitted = false;
    this.submittedSub = false;
  }

  get getDemoForm() {
    return this.demoForm.controls;
  }
  onResize(event: any) {
    this.innerWidth = event.target.innerWidth;
  }

}
